import React from 'react';
import { connect } from 'react-redux';
import {
  paginationToNextPage,
  paginationToPrevPage,
  paginationGoToPage,
} from '@/actions';
import { getPaginationTotalPagesNum } from '@/helpers/pagination';
import { PAGINATION_PAGE_SIZE } from '@/constants';
import FloatingButtons from './FloatingButtons.jsx';

const mapStateToProps = state => ({
  isColored: state.core.isColored,
  zoomState: state.core.zoomState,
  pagesOrder: state.core.pagesOrder,
  paginationPageNum: state.core.paginationPageNum,
  colorSchema: state.core.colorSchema,
  targetDevice: state.core.targetDevice,
  isMultiColored: state.core.isMultiColored,
  areSectionsHidden: state.core.areSectionsHidden,
  scaleCoef: state.core.scaleCoef,
});

const mapDispatchToProps = dispatch => ({
  paginationToPrevPage: () => dispatch(paginationToPrevPage()),
  paginationToNextPage: () => dispatch(paginationToNextPage()),
  paginationGoToPage: val => dispatch(paginationGoToPage(val)),
});

const mergeProps = (stateProps, dispatchProps) => {
  const { pagesOrder, paginationPageNum } = stateProps;

  return {
    isAvailableNavigation: !!pagesOrder.length,
    paginationPageNum,
    paginationPagesTotal: getPaginationTotalPagesNum(pagesOrder),
    paginationPageSize: PAGINATION_PAGE_SIZE,
    paginationItemsTotal: pagesOrder.length,

    ...dispatchProps,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FloatingButtons);
